import React, { Component } from 'react';
import styled from 'styled-components';
import { Link, NavLink } from 'react-router-dom';
import { I18n } from 'react-i18next';
import { OnUpdate } from 'rrc';
import scrollToElement from 'scroll-to-element';
import Headroom from 'headroom.js';

import Container from 'components/Container';
import LanguageSelect from './elements/LanguageSelect';
import Icon from './elements/Icon';
import NavigationMobile from './elements/NavigationMobile';

import imgLogo from 'src/assets/images/logo.svg';

import { t, getBaseLocaleURL } from 'src/utils/translate';

const links = [
  {
    title: t('links.home'),
    url: '/',
  },
  {
    title: t('links.plans'),
    url: '/plans',
  },
  {
    title: t('links.interiors'),
    url: '/interiors',
  },
  {
    title: t('links.neighbourhood'),
    url: '/neighbourhood',
  },
  {
    title: t('links.amenities'),
    url: '/amenities',
  },
  {
    title: t('links.developer'),
    url: '/developer',
  },
  {
    title: t('links.register'),
    url: '/register',
  },
  {
    title: t('links.contact'),
    url: '/contact',
  },
];

const linksLeft = links.slice(0, links.length / 2);
const linksRight = links.slice(links.length / 2, links.length);

export default class Header extends Component {
  state = {
    isMobileMenuOpen: false,
  };

  constructor(props) {
    super(props);
    this.$node = React.createRef();
  }

  componentDidMount() {
    this.lastScrollTop = 0;
    this.headroom = new Headroom(this.$node.current);
    this.headroom.init();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleClickMenu = () => {
    this.setState(state => ({ isMobileMenuOpen: !state.isMobileMenuOpen }));
  };

  handleRouteChange = () => {
    this.setState({ isMobileMenuOpen: false });
  };

  handleClickContact = () => {
    scrollToElement('#footer');
    this.setState({ isMobileMenuOpen: false });
  };

  renderLinks(links, i18n) {
    return (
      <LinksContainer>
        {links.map((link, index) => {
          if (link.url === '/contact') {
            return (
              <a onClick={this.handleClickContact} key={index}>
                <span>{link.title}</span>
              </a>
            );
          }
          return (
            <NavLink exact activeClassName="active" to={`${getBaseLocaleURL(i18n)}${link.url}`} key={index}>
              <span>{link.title}</span>
            </NavLink>
          );
        })}
      </LinksContainer>
    );
  }

  render() {
    return (
      <I18n>
        {(translate, { i18n }) => {
          return (
            <Root
              innerRef={this.$node}
              isMobileMenuOpen={this.state.isMobileMenuOpen}
            >
              <Container>
                <Navigation>
                  {this.renderLinks(linksLeft, i18n)}

                  <Logo to="/">
                    <img src={imgLogo} alt="Ivy Logo" />
                  </Logo>

                  {this.renderLinks(linksRight, i18n)}
                </Navigation>
                <Icon
                  onClick={this.handleClickMenu}
                  isOpen={this.state.isMobileMenuOpen}
                />
              <LanguageSelect />
              </Container>
              <NavigationMobile
                links={links}
                isOpen={this.state.isMobileMenuOpen}
                onClickContact={this.handleClickContact}
              />
              <OnUpdate call={this.handleRouteChange} />
            </Root>
          );
        }}
      </I18n>
    );
  }
}

const Root = styled.header`
  position: relative;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colorBackground};
  z-index: 9999;
  text-align: center;
  transform: translateY(0%);
  transition: all 0.5s;
  &.headroom--unpinned {
    transform: translateY(-100%);
  }
  @media (max-width: ${({ theme }) => theme.headerMobileWidth}) {
    &.headroom--unpinned {
      transform: ${props =>
        props.isMobileMenuOpen ? 'translateY(0%)' : 'translateY(-100%)'};
    }
  }
`;

const Logo = styled(Link)`
  padding: 0 10px;
  width: 50%;
  padding: 5px 0;
  img {
    width: 98px;
    display: block;
    margin: 0 auto;
  }
  @media (max-width: ${({ theme }) => theme.headerMobileWidth}) {
    img {
      width: 63px;
    }
  }
`;

const Navigation = styled.nav`
  text-align: center;
  display: flex;
  width: 100%;
  justify-content: center;
`;

const LinksContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  a {
    color: #fff;
    margin: 0 15px;
    padding-top: 30px;
    font-family: ${({ theme }) => theme.font};
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 1.83px;
    display: flex;
    height: 100%;
    align-items: center;
    cursor: pointer;
    span {
      position: relative;
      &::after {
        content: '';
        width: 12px;
        position: absolute;
        bottom: -5px;
        left: 50%;
        height: 2px;
        background: #fff;
        transform: translateX(-50%) scaleX(0);
        transition: transform 0.25s;
      }
    }
    &.active {
      span {
        &::after {
          transform: translateX(-50%) scaleX(1);
        }
      }
    }
    &:hover {
      span {
        &::after {
          transform: translateX(-50%) scaleX(1);
        }
      }
    }
    @media (max-width: ${({ theme }) => theme.headerMobileWidth}) {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js